import isReseller from '@/middlewares/isReseller';
export default [
    /**
     * FOR RESELLERY ONLY
     */

    {
        path: '/reseller-dashboard',
        component: () => import('@/views/reseller/Dashboard.vue'),
        name: 'ResellerDashboard',
        addtoNav: false,
        meta: {
            navText: 'Dashboard',
            middleware: [isReseller]
        }
    },
    {
        path: '/reseller-reg-products',
        component: () => import('@/views/reseller/RegisteredProducts.vue'),
        name: 'ResellerRegisteredProducts',
        addtoNav: false,
        meta: {
            navText: 'Registered Products',
            middleware: [isReseller]
        }
    },
    {
        path: '/reseller-reg-products/add',
        component: () => import('@/views/reseller/RegisteredProductAdd.vue'),
        name: 'ResellerRegisteredProductAdd',
        addtoNav: false,
        meta: {
            navText: 'Edit Registered Products',
            middleware: [isReseller]
        }
    },
    {
        path: '/reseller-reg-products/:id',
        component: () => import('@/views/reseller/RegisteredProductEdit.vue'),
        name: 'ResellerRegisteredProductEdit',
        addtoNav: false,
        meta: {
            navText: 'Edit Registered Products',
            middleware: [isReseller]
        }
    },

    {
        path: '/reseller-customers',
        component: () => import('@/views/reseller/Customers.vue'),
        name: 'ResellerCustomers',
        addtoNav: false,
        meta: {
            navText: 'Customers',
            middleware: [isReseller]
        }
    },

    {
        path: '/reseller-customer/add',
        component: () => import('@/views/reseller/CustomerAdd.vue'),
        name: 'ResellerCustomersAdd',
        addtoNav: false,
        meta: {
            navText: 'Add Customer',
            middleware: [isReseller]
        }
    },

    {
        path: '/reseller-customer/:customer_id/edit',
        component: () => import('@/views/reseller/CustomerEdit.vue'),
        name: 'ResellerCustomerEdit',
        addtoNav: false,
        meta: {
            navText: 'Edit Customer',
            middleware: [isReseller]
        }
    }
];
